var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"role":"tablist"}},_vm._l((_vm.invoiceTypes),function(invoices,index){return _c('invoice-accordion-item',{key:index,attrs:{"invoices":invoices}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }